import { initialState } from "./common";

export default { ...initialState };
